import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { change, submit, isSubmitting } from "redux-form";
import { UPDATE, GET_ONE } from "react-admin";
import styled from 'styled-components'
import {
  isNil,
  prop,
  path,
  head,
  isEmpty,
  sum,
  filter,
  propEq,
  map,
  length,
} from "ramda";
import {
  showNotification,
  Button,
  SaveButton,
  SimpleForm,
  LongTextInput,
  TextInput,
  FunctionField,
  SelectInput,
} from "react-admin";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Paper from '@material-ui/core/Paper';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import dataProviderFactory from "../dataProvider";
import ForwardIcon from "@material-ui/icons/Forward";
import { required } from "ra-core";
import moment from "moment";




const SanitizedContainer = ({ basePath, ...props }) => {
  return (
    <Grid {...props} />
  );
};
class RefundChargeButton extends Component {
  handleValueChange = (element) => {
    if(element.target.name === "chargeValue"){
      this.setState({ [element.target.name]: element.target.value });
    }
    this.setState({ [element.target.id]: element.target.value });
  };
  
  handleValueChangeBool = (element) => {
    this.setState({ [element.target.id]: element.target.checked });
  };

  handleValueChangeSelect = (e, newValue) => {
    this.setState({refoundChoice : newValue});
  }
  
  state = {
    error: false,
    showDialog: false,
    isOnSubmit: false,
    chargeValue: 0,
    maxReturnValue: 0,
    chargeComments: "",
    internalComments: "",
    MessageResp: "",
    rentalInfo: "",
    itemsRental: "",
    refoundChoice:"global",
    hasError:false,
  };
  
  async componentDidMount() {
    const { record } = this.props;
    console.log("record", this.props.record.payment.id)
    const rental = head(path(["payment", "rentals"], record));
    console.log("rental", rental)
    this.setState({rentalInfo: rental})

    let rentalExtras = await this.getRentalExtras()
    this.setState({itemsRental: rentalExtras})

    const cancelInsuranceValue = !isEmpty(rental.cancel_insurance)
      ? path(["RentalItem", "price"], head(rental.cancel_insurance))
      : 0;

    const charges = prop("charges", record.payment);
    const totalRefunded =
      sum(
        map(
          prop("refunded_value"),
          filter(
            propEq("status", true),
            filter(propEq("to_refund", true), charges)
          )
        )
      ) || 0;

    const vipInsurance =
      length(filter(propEq("id", 1), rental.insurance)) > 0 ? 30 : 0;

    const duration = (date1, date2) => {
      const days = moment(date2).diff(date1, "days");
      return days || 0;
    };

    const hasCancelnsurance = !isEmpty(rental.cancel_insurance);
    const totalPayed =
      sum(map(prop("value"), filter(propEq("status", true), charges))) -
      totalRefunded;

    const days = duration(
      path(["booking", "tour", "effective_start_date"], rental),
      path(["booking", "tour", "effective_end_date"], rental)
    );

    this.setState({
      maxReturnValue: hasCancelnsurance
        ? parseFloat(totalPayed - cancelInsuranceValue).toFixed(2)
        : 0,
      chargeValue: hasCancelnsurance
        ? parseFloat(totalPayed - cancelInsuranceValue).toFixed(2)
        : 0,
      isSubmitting: false,
    });
  }

  getRentalExtras = async () =>{
    let options = [
      {
        id: "global",
        name: "Global"
      }
    ]
    let rentalItems = await dataProviderFactory("rest")
    rentalItems(GET_ONE, `rental_items`, {
      id : this.state.rentalInfo.id
    })
      .then((response) => {
        response.data.map((item)=>{
          if(item.rental_item_type === "vehicle" &&
            this.state.rentalInfo.type !== 1){
            options.push({
              id: "vehicule",
              name: "Vehicule",
            })
          }
          if(item.rental_item_type === "gps_device"){
            options.push({
              id:"gps_device",
              name:"Gps"
            })
          }
          if(item.rental_item_type === "rental_city_fee"){
            options.push({
              id:"city_fee",
              name:"One way"
            })
          }
        })
      })
      .catch((e) => {
        console.error(e);
      });
      if(this.state.rentalInfo.insurance[0] && 
        this.state.rentalInfo.insurance[0].id === 1 && 
        this.state.rentalInfo.type !== 1){
        options.push({
          id: "insurance",
          name: "Vip insurance",
        });
      }    
      if(this.state.rentalInfo.type === 1){
        options.push({
          id: "tour",
          name: "Tour",
        });
      }    
    return options
  }

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleChangeItem = (element, type) => {
    this.setState({ [type]: element.target.value });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false, isSubmitting: false });
  };

  handleSaveClick = () => {
    const { submit } = this.props;
    this.setState({ isOnSubmit: true }, () => {
      submit("charge-send");
    });
  };

  validateFields = () => {
    let error;
    if(this.state.chargeValue <= 0 || this.state.chargeValue === "0"){
      error = true;
    }
    if(this.state.chargeComments === ""){
      error = true;
    }
    if(parseFloat(this.state.chargeValue) >
    Math.abs(this.props.record.value - this.props.record.refunded_value).toFixed(2)){

      error = true;
    }
    if(this.state.isOnSubmit){
      
      error = true;
    }
    if(error){
      
      this.setState({hasError: true})
    }else{
      this.setState({hasError: false})
    }

  };

  handleSubmit = async () => {
    const { history, record } = this.props;
    const rental = head(path(["payment", "rentals"], record));
    const bodyRequest = {
      id: this.props.record.id,
      data: {
        partial: 1,
        status: 2,
        value: this.state.chargeValue,
        comments: this.state.chargeComments,
        internalComments: this.state.internalComments,
        refoundChoice: this.state.refoundChoice,
        payment_id: this.props.record.payment.id,
      },
    };
    const dataProvider = await dataProviderFactory("rest");
    let dataR = "", resp=""
    dataProvider(UPDATE, "charges", bodyRequest)
      .then((msg) => { 
        for(let i in msg)
        {
          dataR = msg[i]
        }    
        if(dataR === 1)
        {
          resp = "Charge refunded with success" 
        } 
        else{
          resp = dataR 
        }         
        this.setState({
          showDialog: false,
          chargeValue: 0,
          isOnSubmit: false,
          chargeComments: "",
          internalComments: "", 
          refoundChoice: "global",
        });
        showNotification(resp);
        if (!isNil(history)) {
          const link = `/${rental.type === 1 ? "tour_clients" : "rental_clients"
            }/${rental.id}/show`;

          history.history.replace(link);
        }
       
      })
      .catch((error) => {
        console.log(error)
        this.setState({ isOnSubmit: false });
        this.props.showNotification(error.message, "error");
      });  
  };

  render() {
    const { record } = this.props;
    const rental = head(path(["payment", "rentals"], record));
    const { showDialog, isOnSubmit } = this.state;

    return (
      <Fragment>
        <Button label="Refund Charge" onClick={this.handleClick}>
          <ForwardIcon titleAccess="Refund Charge" cursor="pointer" />
        </Button>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={showDialog}
          onClose={this.handleCloseClick}
          aria-label="Refund Charge"
        >
          <DialogTitle>
            Refund Charge - {prop("r_first_name", prop("booking", rental))}{" "}
            {prop("r_last_name", prop("booking", rental))}
            {rental.type === 1
              ? ` - ${
                  rental.tour_name
                    ? rental.tour_name
                    : rental.booking.tour.tour_name.tour_name_en
                }`
              : " - Rental"}
            <br />
            {`Start Date ${rental.date_1} to ${rental.date_2}`}
          </DialogTitle>
          <DialogContent >
            <SimpleForm
              form="charge-send"
              resource="charges"
              onSubmit={this.handleSubmit}
              toolbar={null}
              destroyOnUnmount={true}
              validate={this.validateFields}
            >
              <SanitizedContainer container spacing={8}>
                  <Grid item xs={4}>
                    <TextInput
                      source="chargeValue"
                      label={`Value (Eur max) ${parseFloat(this.state.maxReturnValue,2)}`}
                      type="number"
                      defaultValue={parseFloat(this.state.chargeValue)}
                      onChange={this.handleValueChange}
                      validate={required()}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      style={{width:"235px"}}
                    />
                  </Grid>
                  <Grid item xs={3}>
                  <SelectInput 
                    source="Refound"
                    validate={required()}
                    choices={this.state.itemsRental}
                    defaultValue="global"
                    onChange={this.handleValueChangeSelect}
                    // style={{ padding:"20px"}}
                  />
                  </Grid>
              </SanitizedContainer>
              
                  
            
                  
            
              {this.props.record.old_invoice && (
                <FunctionField
                  label="Old Invoice Number"
                  render={() => {
                    return this.props.record.old_invoice;
                  }}
                />
              )}
              <LongTextInput
                source="chargeComments"
                label="Invoice comments"
                type="text"
                onChange={this.handleValueChange}
                validate={required()}
                defaultValue={this.state.chargeComments}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <LongTextInput
                source="internalComments"
                label="IMT internal Comments"
                type="text"
                onChange={this.handleValueChange}
                validate={required()}
                defaultValue={this.state.internalComments}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </SimpleForm>
          </DialogContent>
          <DialogActions>
            {" "}
            <SaveButton
              saving={isOnSubmit}
              onClick={this.handleSaveClick}
              disabled={this.state.hasError}
            />
            <Button label="ra.action.cancel" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isSubmitting: isSubmitting("charge-send")(state),
});

const mapDispatchToProps = {
  change,
  showNotification,
  submit,
};

export default connect(mapStateToProps, mapDispatchToProps)(RefundChargeButton);



// WEBPACK FOOTER //
// ./src/components/refundCharge.js